export const splashScreen = (state = true, action) => {
    switch (action.type) {
        case 'SPLASHSCREEN_HIDE':
            return false;
        default:
            return state
    }
};
